export const initialiseGTM = () => {
  // Check if GTM is already initialized to prevent duplicates
  if (window.wppopen_dataLayer) {
    console.log('GTM already initialized, skipping initialization')
    return
  }
  window.wppopen_dataLayer = window.wppopen_dataLayer || []
  ;(function (w, d, s, l, i) {
    w[l] = w[l] || []
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      // eslint-disable-next-line
      dl = l != 'dataLayer' ? '&l=' + l : ''
    j.async = true
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
    f.parentNode.insertBefore(j, f)
  })(window, document, 'script', 'wppopen_dataLayer', 'GTM-MCJK2K3M')

  console.log('GTM initialized by micro frontend')
}
